import { render, staticRenderFns } from "./CoverageRate.vue?vue&type=template&id=1526b124&scoped=true"
import script from "./CoverageRate.vue?vue&type=script&lang=js"
export * from "./CoverageRate.vue?vue&type=script&lang=js"
import style0 from "./CoverageRate.vue?vue&type=style&index=0&id=1526b124&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1526b124",
  null
  
)

export default component.exports